import React, { Component } from 'react';
import { translate } from 'react-i18next';

const GENERALES = {
  asesor_id: null  
};  
 
class BrokerFormularioAceptar extends Component {


  render() {
    let asesor = this.props.asesor;  
    const { t } = this.props;
    
    if(asesor){
        //console.log("a donde lo manda-------->",this.props.handleQuestionsForm);
        //console.log("datos del asesor-------->",asesor);
        var nombre_asesor = asesor.nombre;
        var nombre_asesor_mayusculas = nombre_asesor.toUpperCase();

        if(asesor.politicas_firmadas == "Si"){
            return(
              <div id="politicasFirmadas" class="survey-page-body" >
                <div class="alert alert-info" >
                 {nombre_asesor_mayusculas}<br></br><br></br>
                 Las politicas ya fueron aceptadas.
                </div>
              </div>
              );            
        }else{



                return(
                  <div id="formularioFirmarPoliticas" class="survey-page-body " >
                    <div class="alert alert-info"  >
                    {nombre_asesor_mayusculas}<br></br><br></br>
                    <p>
                        POLITICAS DE COMPENSACION PARA BROKERS Y ASESORES INMOBILIARIOS
                        <br></br><br></br>
                        IOS OFFICES, a través del programa Certified Parner, otorga comisiones a Brokers y Asesores Inmobiliarios nacionales e internacionales registrados por sus referencias formales de clientes potenciales (prospecto) que se traducen en un cierre exitoso.
                        <br></br><br></br>
                        REGISTRO
                        <br></br><br></br>
                        Pre-registro está disponible y se recomienda para Brokers y/o Asesor Inmobiliario, completando un sencillo formulario. Registrarse en dicha base de datos supone la aceptación formal de nuestras políticas y ayuda a acelerar los procedimientos internos para que en IOS OFFICES podamos hacer un seguimiento inmediato en cada introducción de un nuevo prospecto.
                        <br></br><br></br>
                        REFERENCIAS Y PRESENTACIONES
                        <br></br><br></br>
                        Las referencias de prospectos deben hacerse a través de nuestro call-center preferentemente por correo electrónico. IOS OFFICES responderá aceptando formalmente dicha introducción y comunicará el nombre del asesor comercial interno asignado a la cuenta siempre y cuando IOS OFFICES no haya recibido una solicitud anterior de ese mismo cliente a través de otros medios. En caso de que dos o más Brokers refieran al mismo prospecto, IOS OFFICES aceptará el primer registro formal a menos que se indique lo contrario por el propio prospecto.
                        <br></br><br></br>
                        Información de Call Center:
                        <br></br>
                        · info@iosoffices.com
                        <br></br>
                        · 01-800-3000-IOS (467) (Llamadas Nacionales Gratis)
                        <br></br><br></br>
                        La introducción y / o registro de un prospecto para IOS OFFICES implica automáticamente la aceptación formal de los términos y condiciones aquí establecidas.
                        <br></br><br></br>
                        COMISIONES
                        <br></br><br></br>
                        Las Comisiones a las que hace referencia en la presente política, serán aplicables únicamente a las “Ventas Nuevas”, según dicho termino se define más adelante.
                        <br></br>
                        Las Comisiones serán equivalentes al 10% (diez por ciento) de la contraprestación mensual por el uso de la oficina y según dicho dato sea fijado en la Caratula del Contrato que celebre IOS OFFICES con el SOCIO (Cliente de la “Venta Nueva”). Las Comisiones no serán calculadas sobre los Servicios Adicionales o los Servicios Fijos Adicionales o meses otorgados en cortesía.
                        <br></br>
                        Se entenderá por “Venta Nueva” a la primera contratación de Servicios que realice un prospecto recomendado o referido por los Brokers y Asesores Inmobiliarios que formen parte del programa Certified Partner. 
                    </p>
                    <p>
                        No se entenderá por “Venta Nueva” a las renovaciones automáticas, los decrecimientos de servicios contratados, o cualquier tipo de renovación que venga después de la “Venta Nueva”.
                        <br></br><br></br>
                        EXPANSION / CRECIMIENTO
                        <br></br><br></br>
                        Las compensaciones por expansión y/o crecimiento serán consideradas para los brokers y/o asesores inmobiliarios que acrediten haber participado activamente en el proceso. Se calculan con el 5% del incremento mensual de la oficina y/o tarifa del servicio virtual por el número de meses firmados como periodo inicial obligatorio, hasta 12 meses. A este párrafo le serán válidas las mismas limitantes mencionadas en el párrafo inmediato anterior.
                        <br></br><br></br>
                        RENOVACIONES
                        <br></br><br></br>
                        No se aplicarán comisiones por renovación de contrato, ya sea automática o por celebración nueva, ya que las comisiones sólo se consideran para las nuevas introducciones de venta y crecimientos
                        <br></br><br></br>
                        DOWNGRADES / DECRECIMIENTO
                        <br></br><br></br>
                        Las comisiones por decrecimiento de espacio o cambio de servicio, y/o decrecimiento a servicio virtual no serán aplicables, ya que las comisiones sólo se consideran para las nuevas introducciones de venta y crecimientos
                        <br></br><br></br>
                        PAGOS
                        <br></br><br></br>
                        IOS OFFICES pagará puntualmente las comisiones a los Brokers y/o asesores que acrediten haber participado activamente en la venta, dicho pago se realizará en un periodo no menor a treinta (30) días contados a partir de haber recibido la factura que cumpla con todos los requisitos fiscales aplicables y después de haber confirmado que el cierre de la venta se ha concretado exitosamente. Las comisiones se pagarán directamente a la empresa de corretaje y no al bróker o asesor individual. Si IOS OFFICES no recibe una factura dentro de los 45 días siguientes a la fecha de inicio del servicio y/o la firma del contrato se perderá la comisión. IOS OFFICES se reserva el derecho de facturar o deducir de presentes o futuras comisiones el proporcional de comisión de un contrato que IOS OFFICES no pueda cobrar por incumplimiento del cliente.
                        <br></br><br></br>
                        CONTRATO DE SERVICIOS
                        <br></br><br></br>
                        IOS OFFICES considera como cierre de venta exitosa al Contrato de Servicios plenamente ejecutado cuando el cliente ha iniciado con éxito el uso de la oficina acordada y/o servicio virtual y ha cumplido con los siguientes requisitos:
                        <br></br><br></br>
                        · DOCUMENTACION REQUERIDA CLIENTE
                        <br></br><br></br>
                        o Contrato de servicios firmado frente y reverso (2 originales)
                        <br></br>
                        o Alta de hacienda con domicilio fiscal y RFC            
                    </p>
                    <p>
                        o Identificación oficial del representante legal
                        <br></br>
                        o Comprobante de domicilio
                        <br></br>
                        o Formato de solicitud de servicio completo
                        <br></br>
                        o Información de tarjeta de crédito
                        <br></br>
                        o Pago inicial completo (2 meses de anticipo reembolsable, cuota de inscripción y 1 mes de renta + IVA )
                        <br></br>
                        o Confirmación de recepción de pago en IOS OFFICES.
                        <br></br><br></br>
                        · DOCUMENTACION REQUERIDA DEL BROKER O ASESOR INMOBILIARIO
                        <br></br><br></br>
                        o Previo Registro como Broker / Asesor Inmobiliario
                        <br></br>
                        o Copia de caratula de cuenta bancaria donde se realizara el deposito
                        <br></br>
                        o Factura dentro de los 45 días siguientes a la fecha de inicio del servicio y/o la firma contrato con la siguiente información:
                        <br></br>
                        <br></br>
                        Para facturas de clientes de oficinas y/o servicios en nuestros centros de Monterrey: IOS OFFICES SA DE CV IOF 070123 TD9 Av. Ricardo Margain 575, Edificio C Col. Santa Engracia, San Pedro Garza Garcia, Nuevo León Mexico, 66267 
                        <br></br><br></br>Para facturas de cliente con oficinas y/o servicios en nuestro Centro de Tijuana y Culiacán: IOS OFFICES NORTE SA DE CV ION 101101 6J3 Av. Ricardo Margain 575, Edificio C, Col. Santa Engracia, San Pedro Garza Garcia, Nuevo León, Mexico, 66267 
                        <br></br><br></br>Para facturas de clientes con oficinas y/o servicios en de nuestros centros de Ciudad de México: IOS OFFICES DE MEXICO SA DE CV IOM 080418 AP9 Av. Ricardo Margain 575, Edificio C, Col. Santa Engracia, San Pedro Garza Garcia, Nuevo León Mexico, 66267 
                        <br></br><br></br>Para facturas de cliente con oficinas y/o servicios en nuestros Centros de Guadalajara, Puebla, Querétaro, León: IOS OFFICES CENTRO SA DE CV IOG 090526 AY7 Av. Ricardo Margain 575, Edificio C, Col. Santa Engracia, San Pedro Garza Garcia, Nuevo León, Mexico, 66267 
                        <br></br><br></br>Para facturas de cliente con oficinas y/o servicios en nuestro Centro de Cancún, Villahermosa y Mérida: IOS OFFICES SUR SA DE CV IOS120424 HA0 Av. Ricardo Margain 575, Edificio C , Col. Santa Engracia, San Pedro Garza Garcia, Nuevo León Mexico, 66267
                        <br></br><br></br>
                        ______________________________________________________
                        <br></br><br></br>
                        IOS OFFICES Asesor Inmobiliario            
                    </p>     
                    <p><br></br><br></br>
                      *Aplican cambios sin previo aviso
                      <br></br>**Valido desde Enero 2021
                      <br></br>***Revisado: Enero 2021
                    </p> 
                    </div>

                    <form method="post" onSubmit={this.props.handleQuestionsForm}>
                      <fieldset>
                        <div className="form-group text-center">
                          <button
                            className="btn btn-primary"
                            type="submit">
                            {t('guest.brokerpoliticas.btn_continue')}
                          </button>
                        </div>
                      </fieldset>
                    </form>
                  </div>
                  
                );
        }
    }else{
        return(
          <div id="politicasFirmadas" class="survey-page-body" >
            <div class="alert alert-info" >
             Los datos del Asesor no se encontraron en la base de datos
            </div>
          </div>
          );
    }

  }

}

export default translate('common')(BrokerFormularioAceptar);



// WEBPACK FOOTER //
// ./src/guest/BrokerPoliticas/BrokerFormularioAceptar.js